import React from "react";
import { ClipboardList, Cog, Rocket } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: ClipboardList,
    title: "Onboarding Call",
    body: "We learn your business, your most common questions, your services, pricing, and objections. This is how we train your agent to sound like you.",
  },
  {
    n: "02",
    icon: Cog,
    title: "We Build & Train the Agent",
    body: "We build the AI agent backend, train it on your business data, set up Calendly integration for bookings, and configure lead capture.",
  },
  {
    n: "03",
    icon: Rocket,
    title: "Go Live. Never Miss a Lead.",
    body: "We deploy your agent directly onto your website. From that moment on, your business is a 24/7 operation. Every visitor gets an answer. Every lead gets captured.",
  },
];

export default function HowItWorks() {
  return (
    <section id="process" data-testid="how-it-works-section" className="bg-white fs-section border-y border-black/5">
      <div className="fs-container">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-8 bg-[#C9A84C]" />
            <span className="fs-tag">The Process</span>
          </div>
          <h2 className="font-display text-4xl md:text-6xl uppercase tracking-[0.03em] leading-[0.95] text-[#0A0F1E]">
            From Signed Contract<br />to Live in <span className="text-[#C9A84C]">7 Days.</span>
          </h2>
          <p className="mt-6 text-lg text-[#0F172A]/70 max-w-2xl leading-relaxed">
            We handle everything. You just give us access to your website and
            we take it from there.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6 lg:gap-8 relative">
          {STEPS.map((s, i) => (
            <article key={i} data-testid={`process-step-${i}`} className="fs-card-light relative">
              <div className="flex items-start justify-between">
                <span className="font-display text-5xl text-[#C9A84C] tracking-[0.04em]">{s.n}</span>
                <span className="h-11 w-11 rounded-md border border-[#0A0F1E]/15 flex items-center justify-center text-[#0A0F1E]">
                  <s.icon size={20} strokeWidth={1.6} />
                </span>
              </div>
              <h3 className="mt-8 font-display text-2xl tracking-[0.04em] uppercase text-[#0A0F1E]">
                {s.title}
              </h3>
              <p className="mt-3 text-sm text-[#0F172A]/70 leading-relaxed">{s.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
